// 학교급/학기/출판사 선택 정적 데이터 — 위글루(3trmXRiM…)에서 코드 내장(2026-07-31).
// 순수 설정값이라 CMS 없이 상수로 관리한다(마지막 위글루 수정 2025-12-29, 사실상 동결).
// 소비: publishers.KR / semesters.KR (build 카테고리·출판사 필터).
// 갱신 시 이 파일 수정 → 배포.
//
// ⚠️ quiz-admin-app 에 동일 파일이 복제돼 있다
// (apps/quiz-admin-app/src/shared/category/schoolSelection.const.ts).
// 위글루가 원격 단일 소스였을 때는 문제 없었지만 내장하면서 로컬 복제가 됐다.
// 공유 패키지로 뽑기엔 과한 정적 설정값이라(quiz-app/quiz-admin 은 zepetoful.api 류
// 소규모 연동 코드를 서로 복사해 쓰는 기존 관례가 있다) 의도적으로 중복을 남겼다 —
// 이 파일을 고치면 반드시 저 파일도 같이 고칠 것 (Zebi 리뷰 PR #3422).

// SelectionSchoolInfo 는 views/build 소유 타입이지만, shared/category 의
// 다른 파일(schoolInfo.const.ts 등)도 이미 같은 경로로 참조하는 기존 관례를 따른다.
import { type SelectionSchoolInfo } from '@/views/build/type';

export const SCHOOL_SELECTION_INFO = {
  publishers: {
    KR: [
      {
        label: '천재교과서',
        value: 'CHUNJAETEXT',
        showSchoolTypes: ['primary', 'middle', 'high'],
        hideGrades: [1, 2],
      },
      {
        label: '천재교육',
        value: 'CHUNJAE',
        showSchoolTypes: ['primary', 'middle', 'high'],
        hideGrades: [1, 2],
      },
      {
        label: '아이스크림미디어',
        value: 'ISCREAMMEDIA',
        showSchoolTypes: ['primary', 'middle', 'high'],
        hideGrades: [1, 2],
      },
      {
        label: '동아출판',
        value: 'DONGA',
        showSchoolTypes: ['primary', 'middle', 'high'],
        hideGrades: [1, 2],
      },
      {
        label: '비상교과서',
        value: 'VISANGTEXT',
        showSchoolTypes: ['primary', 'middle', 'high'],
        hideGrades: [1, 2],
      },
      {
        label: '비상교육',
        value: 'VISANGEDU',
        showSchoolTypes: ['primary', 'middle', 'high'],
        hideGrades: [1, 2],
      },
      {
        label: '금성출판사',
        value: 'KUMSUNG',
        showSchoolTypes: ['primary', 'middle', 'high'],
        hideGrades: [1, 2],
      },
      {
        label: '국정교과서',
        value: 'NATIONAL',
        showSchoolTypes: ['primary', 'middle', 'high'],
        hideGrades: [],
      },
      {
        label: '미래엔',
        value: 'MIRAEN',
        showSchoolTypes: ['primary', 'middle', 'high'],
        hideGrades: [1, 2],
      },
      {
        label: '지학사',
        value: 'JIHAK',
        showSchoolTypes: ['primary', 'middle', 'high'],
        hideGrades: [1, 2],
      },
      {
        label: '씨마스',
        value: 'CMASS',
        showSchoolTypes: ['primary', 'middle', 'high'],
        hideGrades: [1, 2],
      },
      {
        label: 'YBM',
        value: 'YBM',
        showSchoolTypes: ['primary', 'middle', 'high'],
        hideGrades: [1, 2],
      },
      {
        label: '교학사',
        value: 'KYOHAK',
        showSchoolTypes: ['primary', 'middle', 'high'],
        hideGrades: [1, 2],
      },
      {
        label: '김영사',
        value: 'GIMMYOUNG',
        showSchoolTypes: ['primary', 'middle', 'high'],
        hideGrades: [1, 2],
      },
      {
        label: '대교',
        value: 'DAEKY',
        showSchoolTypes: ['primary', 'middle', 'high'],
        hideGrades: [1, 2],
      },
      {
        label: '기타',
        value: 'OTHER',
        showSchoolTypes: ['primary', 'middle', 'high'],
        hideGrades: [],
      },
    ],
  },
  semesters: {
    KR: {
      primary: [1, 2, 999],
      middle: [1, 2, 999],
      high: [1, 2, 999],
    },
  },
} as unknown as SelectionSchoolInfo;
